import { Textarea as MantineTextarea, TextareaProps as MantineTextareaProps } from "@mantine/core";
import styles from "./styles.module.css";

export interface TextareaProps extends MantineTextareaProps {
  className?: string;
}

const Textarea = ({ ...props }: TextareaProps) => {
  return (
    <MantineTextarea
      {...props}
      className={`${styles.textareaRoot} ${props.className || ""}`}
      classNames={{ label: styles.textareaLabel }}
    />
  );
};

export default Textarea;
